<div class="result-container-header">
    <div class="vertical-center estimate-title-section">
        <a matTooltip="{{ variables.goBack}}" matTooltipPosition="below" aria-label="{{ variables.goBack}}"
            (click)="goToDashboard()">
            <mat-icon class="header-icon-img">arrow_circle_left</mat-icon>

        </a>
        <h4 class="result-title">
            {{ variables?.result || 'Resultado' }} - <span class="estimate-name">{{ estimateName }}</span>
        </h4>
    </div>
</div>

<mat-tab-group animationDuration="200ms" [mat-stretch-tabs]="false">
    <mat-tab>
        <ng-template mat-tab-label>
            <mat-icon class="tab-icon">description</mat-icon>
            {{ variables?.estimation || 'Estimación' }}
        </ng-template>
        <app-result [estId]="estId" [sideNavStatus]="isOpen || shouldPinSidenav"
            (estimateNameChange)="onEstimateNameChange($event)"
            (estimateState)="onEstimateStateDetect($event)"></app-result>
    </mat-tab>
    @if (canCheckImputationAndDeviation()) {
    <mat-tab>
        <ng-template mat-tab-label>
            <mat-icon class="tab-icon">schedule</mat-icon>
            {{ variables?.realImputation || 'Imputación Real' }}
        </ng-template>
        <ng-template matTabContent>
            <app-imputacion-real [sideNavStatus]="isOpen || shouldPinSidenav"></app-imputacion-real>
        </ng-template>
    </mat-tab>
    <mat-tab>
        <ng-template mat-tab-label>
            <mat-icon class="tab-icon">bar_chart</mat-icon>
            {{ variables?.deviationAnalysis || 'Análisis de Desviaciones' }}
        </ng-template>
        <ng-template matTabContent>
            <app-analisis-desviaciones [sideNavStatus]="isOpen || shouldPinSidenav"></app-analisis-desviaciones>
        </ng-template>
    </mat-tab>
    }
</mat-tab-group>